import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import './MobileBottomNav.css';

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5.2v-5.5h-3.6V21H5a1 1 0 0 1-1-1v-9.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  ),
  streams: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M5 6.5h14v9.2H5V6.5Zm3.2 11.3h7.6M9.2 10.2l5 2.7-5 2.7v-5.4Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  news: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M6 5.5h10.5A2.5 2.5 0 0 1 19 8v10.5H7.5A2.5 2.5 0 0 1 5 16V7a1.5 1.5 0 0 1 1.5-1.5H6Zm3 4h6.5M9 13h6.5M9 16.5h4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  scores: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 4.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm0 0v15M4.8 9.2h14.4M4.8 14.8h14.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
};

const MobileBottomNav = () => {
  const { t } = useLocale();
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(false);
  }, [pathname]);

  useEffect(() => {
    let lastY = window.scrollY || 0;
    let ticking = false;
    const THRESHOLD = 8;
    const TOP_SHOW = 48;

    const update = () => {
      const y = window.scrollY || 0;
      const delta = y - lastY;

      if (y <= TOP_SHOW) {
        setHidden(false);
      } else if (delta > THRESHOLD) {
        setHidden(true);
      } else if (delta < -THRESHOLD) {
        setHidden(false);
      }

      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const items = [
    { to: '/', label: t.nav.homeShort || t.nav.home, icon: 'home', end: true },
    { to: '/streams', label: t.nav.streamsShort || t.nav.streams, icon: 'streams' },
    { to: '/news', label: t.nav.newsShort || t.nav.news, icon: 'news' }
    // Scores temporarily hidden
  ];

  return (
    <nav
      className={`lf-bottom-nav${hidden ? ' is-hidden' : ''}`}
      aria-label="Main"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `lf-bottom-nav__item${isActive ? ' is-active' : ''}`
          }
        >
          <span className="lf-bottom-nav__icon">{ICONS[item.icon]}</span>
          <span className="lf-bottom-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
